import { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeaderWithActions } from '@evertrue/et-components';
import moment from 'moment';
import DatePickerDropdown from 'components/calendar/date-picker-dropdown';
import TimeDropdown from 'components/forms/time-dropdown';
import FormField from 'components/forms/form-field';

const ScheduleEmailModal = ({ isOpen, onClose, onSchedule }) => {
  // Initialize with current time + next 30 minute interval
  const now = moment();
  const defaultTime = now
    .clone()
    .add(30 - (now.minute() % 30), 'minutes')
    .startOf('minute');

  const defaultSelectedDate = now.clone().startOf('day');
  const defaultSelectedTime = {
    label: defaultTime.format('hh:mm a'),
    value: defaultTime.toISOString(),
  };

  const [selectedDate, setSelectedDate] = useState(defaultSelectedDate);
  const [selectedTime, setSelectedTime] = useState(defaultSelectedTime);

  // Convert selected date/time to epoch and pass to handler
  const handleSchedule = () => {
    const dateTime = moment(selectedDate)
      .startOf('day')
      .add(moment(selectedTime.value).hours(), 'hours')
      .add(moment(selectedTime.value).minutes(), 'minutes');

    onSchedule(dateTime.valueOf() / 1000);
    setSelectedDate(defaultSelectedDate);
    setSelectedTime(defaultSelectedTime);
    onClose();
  };

  const isLateNight = now.hours() >= 23;

  const date = new Date();
  const timeString = date.toLocaleTimeString('en-us', { timeZoneName: 'short' });
  const userTimezone = timeString.split(' ').pop();

  return (
    <Modal isOpen={isOpen} closeModal={onClose}>
      <ModalHeaderWithActions
        title="Schedule"
        closeModal={() => {
          setSelectedDate(defaultSelectedDate);
          setSelectedTime(defaultSelectedTime);
          onClose();
        }}
        submitLabel="Schedule Send"
        onSubmit={handleSchedule}
      />
      <ModalBody>
        <FormField label="Date" inlineLabel={true}>
          <DatePickerDropdown
            disabledDays={{
              before: new Date(),
              ...(isLateNight && { before: now.add(1, 'day').toDate() }),
            }}
            triggerClassName="schedule-email-date-picker"
            chevronClassName="date-picker-chevron"
            date={selectedDate}
            onDayClick={setSelectedDate}
          />
        </FormField>
        <FormField label={'Time ' + (userTimezone ? `(${userTimezone})` : '')} inlineLabel={true}>
          <TimeDropdown
            className="schedule-email-time-picker"
            increment={30}
            onChange={setSelectedTime}
            value={selectedTime}
            selectedDate={selectedDate}
          />
        </FormField>
      </ModalBody>
    </Modal>
  );
};

ScheduleEmailModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSchedule: PropTypes.func.isRequired,
};

export default ScheduleEmailModal;
